import { useState } from 'react'

import * as d from '@/lib/dates'
import { guests } from '@/lib/format'

export interface Search {
  checkIn: string
  checkOut: string
  adults: number
  children: number
}

interface Props {
  value: Search
  onChange(next: Search): void
  compact?: boolean
}

/** Панель поиска: даты и гости. Одна на все экраны, чтобы выбор не терялся
 *  при переходе из каталога в карточку объекта. */
export function SearchBar({ value, onChange, compact }: Props) {
  const [open, setOpen] = useState(false)
  const nights = value.checkIn && value.checkOut
    ? d.nightsBetween(value.checkIn, value.checkOut)
    : 0

  function setDates(checkIn: string, checkOut: string) {
    // Выезд не может быть раньше заезда — молча сдвигаем, а не показываем ошибку.
    const fixed = checkOut > checkIn ? checkOut : d.addDays(checkIn, 1)
    onChange({ ...value, checkIn, checkOut: fixed })
  }

  const total = value.adults + value.children

  return (
    <div className={compact ? 'search search--compact' : 'search'}>
      <label className="search__field">
        <span className="search__label">Заезд</span>
        <input
          className="search__input"
          type="date"
          value={value.checkIn}
          min={d.today()}
          onChange={(e) => e.target.value && setDates(e.target.value, value.checkOut)}
        />
      </label>

      <label className="search__field">
        <span className="search__label">Выезд</span>
        <input
          className="search__input"
          type="date"
          value={value.checkOut}
          min={d.addDays(value.checkIn || d.today(), 1)}
          onChange={(e) => e.target.value && setDates(value.checkIn, e.target.value)}
        />
      </label>

      <div className="search__field search__field--guests">
        <span className="search__label">Гости</span>
        <button
          type="button"
          className="search__input search__trigger"
          onClick={() => setOpen((v) => !v)}
        >
          {guests(total)}
        </button>

        {open && (
          <div className="guests">
            <Counter
              label="Взрослые"
              value={value.adults}
              min={1}
              onChange={(adults) => onChange({ ...value, adults })}
            />
            <Counter
              label="Дети"
              value={value.children}
              min={0}
              onChange={(children) => onChange({ ...value, children })}
            />
            <button className="guests__done" type="button" onClick={() => setOpen(false)}>
              Готово
            </button>
          </div>
        )}
      </div>

      {nights > 0 && <span className="search__nights">{d.formatRange(value.checkIn, value.checkOut)}</span>}
    </div>
  )
}

function Counter({
  label,
  value,
  min,
  onChange,
}: {
  label: string
  value: number
  min: number
  onChange(v: number): void
}) {
  return (
    <div className="counter">
      <span>{label}</span>
      <div className="counter__controls">
        <button type="button" onClick={() => onChange(Math.max(min, value - 1))} disabled={value <= min}>
          −
        </button>
        <span className="counter__value">{value}</span>
        <button type="button" onClick={() => onChange(Math.min(10, value + 1))}>
          +
        </button>
      </div>
    </div>
  )
}
